<template>

    <div class="my_footer" id="footer" style="bottom: 0;">
        <div class="footer_top_border clearfix">
            <img src="../assets/footer-top.png" width="100%">
        </div>
        <footer>
            <b-container class="footer_container">
                <b-row class="footer_content">
                    <b-col cols="6" lg="3" v-for="item in menuList" :key="item.menuId" class="footer_item">
                        <img src="../assets/footer-item-top.png">
                        <p class="title">{{ item.menuNam }}</p>
                        <ul>
                            <li v-for="(item2, index) in item.children" @click="navClick(item,item2)" :key="index">
                                {{ item2.menuNam }}
                            </li>
                        </ul>
                    </b-col>

                    <!--          <b-col md="0"></b-col>-->
                    <b-col class="footer_logo" cols="12" lg="3">
                        <div class="logo_box">
                            <img src="../assets/footer-logo.png" class="logo_img">

                            <div style="position: relative;width: 168px;margin: 0 auto">
                                <img src="../assets/ercode.png">
                                <img :src="codeImg" class="code_img">
                            </div>

                        </div>
                    </b-col>
                </b-row>
            </b-container>

            <b-container class="footer-bottom">
                <p>
                    {{ copyright[languageNum - 1].title }}
                </p>
            </b-container>

        </footer>
    </div>
</template>

<script>

    import {getDictData} from '../api/HomeService'

    export default {
        name: "Footer",
        props: {
            menuList: Array
        },
        data() {
            return {
                codeImg: '',
                languageNum: parseInt(window.localStorage.getItem("languageNum")),
                copyright: [
                    {id: 1, title: 'Copyright ©2021 Airdisk.cc. All Rights Reserved.'},
                    {id: 2, title: 'Copyright ©2021 Airdisk.cc. All Rights Reserved.'},
                    {id: 3, title: '版权 ©2021 Airdisk.cc. 保留所有权利.'},
                    {id: 4, title: 'Copyright ©2021 Airdisk.cc.保留所有權利'},
                    {id: 5, title: 'Copyright ©2021 Airdisk.cc. Alle Rechte vorbehalten.'},
                    {id: 6, title: 'Copyright ©2021 Airdisk.cc. Tous droits réservés.'},
                    {id: 7, title: 'Copyright ©2021 Airdisk.cc. Tutti i diritti riservati.'},
                    {id: 8, title: 'Copyright ©2021 Airdisk.cc. Todos los derechos reservados.'},
                ],
            }
        },
        methods: {
            navClick(item, item2) {
                let lang = '/zh';

                if (this.languageNum == 1) {
                    lang = '/en';
                } else if (this.languageNum == 2) {
                    lang = '/en-us';
                } else if (this.languageNum == 3) {
                    lang = '/zh-hans';
                } else if (this.languageNum == 4) {
                    lang = '/zh-hant';
                } else if (this.languageNum == 5) {
                    lang = '/de';
                } else if (this.languageNum == 6) {
                    lang = '/fr';
                } else if (this.languageNum == 7) {
                    lang = '/it';
                } else if (this.languageNum == 7) {
                    lang = '/es';
                }

                document.body.scrollTop = document.documentElement.scrollTop = 0
                //设置浏览器title
                document.title = item2.title || item.title;

                if (item2.description) {
                    document.getElementsByTagName('meta')[1].setAttribute("content", item2.description || item.description);
                }

                if (item2.keywords) {
                    document.getElementsByTagName('meta')[2].setAttribute("content", item2.keywords || item.keywords);
                }

                window.localStorage.setItem("curNav", JSON.stringify(item2));

                if (item.menuUrl === "/products") {
                    this.$router.push(lang + item.menuUrl + "?type=" + item2.menuNam)
                    return
                }
                this.$router.push(lang + item2.menuUrl)
            },
        },
        mounted() {

            getDictData("common_config", data => {
                if (data[0]) {
                    this.codeImg = data[0].dictValue
                }
            })
        }
    }
</script>

<style scoped lang="scss" src="../css/footer.scss"></style>